import { Controller, useFormContext } from "react-hook-form";
import { Box } from "@mui/material";
import { StyledTextField } from "./StyleInputs";
const EmailField = ({ field }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const errorMessage = errors[field.id]?.message;

  return (
    <Box sx={{ mb: 3 }}>
      <Controller
        name={field.id}
        control={control}
        defaultValue=""
        rules={{
          required: field.required ? `${field.label} is required` : false,
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: "Invalid email address",
          },
        }}
        render={({ field: { onChange, value, ref } }) => (
          <StyledTextField
            fullWidth
            placeholder={field.placeholder}
            type="email"
            value={value}
            onChange={onChange}
            inputRef={ref}
            error={!!errorMessage}
            helperText={errorMessage}
            variant="outlined"
            label={field.label}
            required={field.required}
          />
        )}
      />
    </Box>
  );
};

export default EmailField;
